export const GA_MEASUREMENT_ID = "G-QRX2V505HG";

const PRODUCT_BY_PATH = [
  { match: "/produk/animax-acrylic-sheet", name: "Acrylic" },
  { match: "/produk/baja-ringan-galvalum", name: "Galvalum" },
];

export const getProductNameFromPath = (path = "") => {
  return PRODUCT_BY_PATH.find((item) => path.startsWith(item.match))?.name || "Company";
};

export const trackEvent = (eventName, params = {}) => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;

  window.gtag("event", eventName, {
    event_category: params.category || "engagement",
    event_label: params.label,
    value: params.value,
    ...params,
  });
};

export const trackPageView = (path) => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;

  window.gtag("config", GA_MEASUREMENT_ID, {
    page_path: path,
  });
};

export const trackProductPageView = (productName, path) => {
  trackEvent("product_page_viewed", {
    category: "product",
    label: productName,
    product_name: productName,
    page_path: path,
  });
};
